let storeActions = null;

export const registerGlobalActions = (actions) => {
    storeActions = actions;
};

export const globalActions = {
    showHomePage: () => storeActions?.showHomePage(),
    refreshContentSummary: () => storeActions?.refreshContentSummary(),
    setSessionUser: user => storeActions?.setSessionUser(user),
};
